export function disablePointerEvents(parentNode: Document, draggableClassName: string): void {
    // Give all other draggable items the `no-hover` class, to prevent activation of hover CSS state.
    Array.from(parentNode.getElementsByClassName(draggableClassName)).forEach((el) => {
        el.classList.add('no-hover');
    });
    // Prevent pointer-events on `btn` classes & tooltips
    Array.from(parentNode.getElementsByClassName('btn')).forEach((btn) => {
        (btn as HTMLElement).style.setProperty('pointer-events', 'none');
    });
    Array.from(parentNode.getElementsByClassName('tooltip')).forEach((tooltip) => {
        (tooltip as HTMLElement).style.setProperty('display', 'none');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-label')).forEach((label) => {
        (label as HTMLElement).style.setProperty('display', 'none');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-markers')).forEach((label) => {
        (label as HTMLElement).style.setProperty('display', 'none');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-crosshair')).forEach((label) => {
        (label as HTMLElement).style.setProperty('display', 'none');
    });
}

export function enablePointerEvents(parentNode: Document, draggableClassName: string): void {
    Array.from(parentNode.getElementsByClassName('btn')).forEach((btn) => {
        (btn as HTMLElement).style.setProperty('pointer-events', 'auto');
    });
    Array.from(parentNode.getElementsByClassName(draggableClassName)).forEach((el) => {
        el.classList.remove('no-hover');
    });
    Array.from(parentNode.getElementsByClassName('tooltip')).forEach((tooltip) => {
        (tooltip as HTMLElement).style.setProperty('display', 'initial');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-label')).forEach((label) => {
        (label as HTMLElement).style.setProperty('display', 'initial');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-markers')).forEach((label) => {
        (label as HTMLElement).style.setProperty('display', 'initial');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-crosshair')).forEach((label) => {
        (label as HTMLElement).style.setProperty('display', 'initial');
    });
}
